export default function Logo({ variant = "dark", className = "h-9" }) {
  const src = variant === "light" ? "/logo-tsc-light.png" : "/logo-tsc-dark.png";
  return <img src={src} alt="The Social Club — Porto, PT" className={`${className} w-auto object-contain`} />;
}
